import { Box, Center, HStack, Text, useTheme, VStack } from "native-base";
import React from "react";
import type { TFunction } from "react-i18next";

import type { GeneratedRecipeMeal, RecipeMeal } from "../services/backendTypes";

type MealForEditScreenBase = GeneratedRecipeMeal | RecipeMeal;
type MealForEditScreen = MealForEditScreenBase & {
  portions_to_plan?: number;
};

type PreparationStepsRouteProps = {
  bufferedRecipeMeal: MealForEditScreen;
  t: TFunction;
};

const PreparationStepsRoute = ({ bufferedRecipeMeal, t }: PreparationStepsRouteProps): JSX.Element => {
  const theme = useTheme();

  return (
    <Box flex={1}>
      <Text fontSize="lg" fontWeight="600" color="gray.800" mb={6}>
        {t("recipe_detail.preparation_steps_tab_title")}
      </Text>
      <VStack space={4}>
        {bufferedRecipeMeal?.directions?.map((direction, directionIndex) => (
          <HStack key={directionIndex} alignItems="flex-start" space={4}>
            <Center width={8} height={8} borderRadius="full" bg="primary.500" shadow={2}>
              <Text color="white" fontSize="sm" fontWeight="600">
                {directionIndex + 1}
              </Text>
            </Center>
            <Text color="gray.600" flex={1} fontSize="md" lineHeight="22px" testID={`direction-${directionIndex}`}>
              {direction.text}
            </Text>
          </HStack>
        ))}
      </VStack>
    </Box>
  );
};

export default PreparationStepsRoute;
